<template>
  <div class="stock-page">
    <div :class="['block', {'block-pop': popped}]">
      <div class="hd" v-show="!popped">
        <img :src="'/static/'+theme+'/images/stock/yjjl.png'" class="tit">
      </div>
      <div class="list-box">
        <div class="table ch3-table">
          <table>
            <thead>
              <tr>
                <th width="popped?180:90">类型</th>
                <th>物料名称</th>
                <th>货位号</th>
                <th>呆滞时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in yjjlList" class="alarm-type-1">
                <td><span v-text="item.WarnningTypeString"></span></td>
                <td>
                  <span class="tdtxt" v-text="item.MaterialName"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.MaterialName"></span>
                  </div>
                </td>
                <td  @click="numberHref(item.ShefGridNo)">
                  <span class="tdtxt" v-text="item.ShefGridNo"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.ShefGridNo"></span>
                  </div>
                </td>
                <td>
                  <span class="tdtxt" v-text="item.Remark"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.Remark"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="page-container">
          <v-pagination size="mini" :total="totalCount" :display="pageSize" :current-page='pageIndex' @pagechange="pageChange"></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import pagination from '@/components/widgets/Pagination'
export default{
  components: {
    'v-pagination': pagination,
  },
  props: ['theme'],
  inject: ["reload"],  //注入reload方法
  data() {
    return {
      yjjlListAll: [],
      yjjlList: [],
      popped: false,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 4,
    }
  },
  watch: {
    popped(val) {
      if(!val) {
        this.pageSize = 4;
      } else {
        this.pageSize = 4*4;
      }
      this.pageChange(1);
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    window.gbfc_popupWindow = this.popupWindow;
    window.gbfc_getData = this.getData;
    //window.gbfc_reloadPage = this.reload;
    //初始化
    this.$initPage(this);
    if(this.$route.query.popped == 1) {
      this.popped = true;
    }
  },
  methods: {
    popupWindow(val) {
      this.popped = val;
    },
    resetData(param) {
      //预警记录
      this.getYjjlList();
    },
    getData() {

      return JSON.stringify(this.yjjlListAll);
    },
    getYjjlList() {
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Inv_EarlyWarnnings_Info', {
          "WareHouseCode": window.PYKWareHouseCode,
        }, 'post', function(res) {  //success

          self.yjjlListAll = res.retData.Rows;
          self.yjjlList = self.$dataPage(res.retData.Rows, self.pageIndex, self.pageSize);
          self.totalCount = res.retData.TotalCount ? res.retData.TotalCount : res.retData.Rows.length;
        }, function(res) {  //fail
      });
    },
    pageChange(pageIndex) {
      console.log('pageIndex', pageIndex);
      this.pageIndex = pageIndex;
      this.getYjjlList();
    },
    numberHref(num){
      unitysend_shelfgridNo(num);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiayan/stock/StockChart3.vue